import { Space } from 'antd';
import React from 'react';

import DetailPageHeader from '../components/detail-page-header';
import { SPACING } from '../theme/tokens';

function OrdersContainer(): React.ReactElement {
  return (
    <Space size={SPACING.lg} align="start" orientation="vertical">
      <DetailPageHeader title="Orders" />
    </Space>
  );
}

export default OrdersContainer;
